import React, {useEffect, useState} from 'react';
import {doc, getDoc} from 'firebase/firestore';
import {FaExclamationTriangle} from 'react-icons/fa';
import {db} from '../utils/firebase';
import {useLang} from '../context/LanguageContext';
import {DEFAULT_TECH_ISSUE_BANNER_ENABLED} from '../utils/techIssueBanner';

const TechIssueBanner = () => {
    const {t} = useLang();
    const [enabled, setEnabled] = useState(false);

    useEffect(() => {
        const load = async () => {
            try {
                const snap = await getDoc(doc(db, 'appSettings', 'techIssueBanner'));
                setEnabled(snap.exists() && typeof snap.data().enabled === 'boolean'
                    ? snap.data().enabled
                    : DEFAULT_TECH_ISSUE_BANNER_ENABLED);
            } catch (err) {
                setEnabled(DEFAULT_TECH_ISSUE_BANNER_ENABLED);
            }
        };
        load();
    }, []);

    if (!enabled) {
        return null;
    }

    return (
        <div className="w-full max-w-[400px] mx-auto my-2 px-3 py-2 rounded-lg bg-yellow-100 border border-yellow-500 text-yellow-900 text-xs flex items-start gap-2">
            <FaExclamationTriangle className="shrink-0 mt-0.5 text-yellow-600"/>
            <p className="leading-snug">{t('txt.techIssueBanner')}</p>
        </div>
    );
};

export default TechIssueBanner;
